export enum GraphicsFilterEnum {
  MACROACTIVO = "macroactive",
  SUBACTIVO = "instrumentType",
  MONEDA = "currency",
  PLAZO = "rangleTerm",
  CLASE_DE_INVERSION = "investmentClass",
  CALIFICACION = "rating",
  EMISOR = "issuerName",
}

export type RawData = {
  rangleTerm: string;
  macroactive: string;
  instrumentType: string;
  currency: string;
  investmentClass: string;
  rating: string;
  issuerName: string;
  localCurrencyValuation: number;
};

export interface Portfolio {
  id: string;
  name: string;
  nit: string;
  dv: number;
  decevalAccount: number;
  DCVAccount: number;
}

export interface InstrumentType {
  id: string;
  name: string;
};

export interface Instrument {
  id: string;
  mnemonic: string;
  instrumentType: string;
  isin: string;
  currency: string;
  interestRate: string;
  frequency: string;
  issuanceDate: string;
  maturityDate: string;
  issuerName: string;
  rating: string;
  validation: string;
};

export interface ResponseInstrumentTypes {
  success: boolean;
  data?: InstrumentType[];
  error?: string;
  message?: string;
}

export interface SensitivityMeasures {
  id: string;
  portfolio: string;
  mnemonic: string;
  instrumentType: string;
  instrument: string;
  currency: string;
  facialRateType: string;
  facialRate: string | number;
  mode: string;
  periodicity: string;
  emission: string;
  maturity: string;
  localCurrencyValuation: number;
  percentage: number;
  duration: number;
  modifiedDuration: number;
  convexity: number;
  DV01: number;
};

export interface SensitivityMeasuresByPortfolio {
  portfolio: string;
  localCurrencyValuation: number;
  duration: number;
  modifiedDuration: number;
  convexity: number;
  DV01: number;
};

export interface ResponseSensitivityMeasures {
  success: boolean;
  data?: SensitivityMeasures[];
  error?: string;
  message?: string;
}

export interface DashboardGraphics {
  id: string;
  portfolio: string;
  issuerName: string;
  rating: string;
  macroactive: string;
  instrumentType: string;
  currency: string;
  rangleTerm: string;
  investmentClass: string;
  localCurrencyValuation: number;
};

export interface ResponseDashboardGraphics {
  success: boolean;
  data?: DashboardGraphics[];
  error?: string;
  message?: string;
}

export interface ResponseInstruments {
  success: boolean;
  data?: Instrument[];
  error?: string;
  message?: string;
}

export interface ResponsePortfolios {
  success: boolean;
  data?: Portfolio[];
  error?: string;
  message?: string;
}

export interface FutureFlowEntityKV {
  id: string;
  portfolio: string;
  instrument: string;
  flowDate: string;
  value: number;
}

export interface FutureFlowCreateRequest {
  portfolio: string;
  instrument: string;
  flowDate: string;
  value: number;
}

export interface FutureFlowEntity {
  id: string;
  portfolio: Portfolio;
  instrument: Instrument;
  flowDate: Date;
  value: number;
}

export interface ResponseFutureFlowKV {
  success: boolean;
  data?: FutureFlowEntityKV[];
  error?: string;
  message?: string;
}